import axios from 'axios'

const url=process.env.REACT_APP_APPROVAL_URL;


export const getVideoKycRequests=async(filters,page,setData,isLoading)=>{
    try {
        isLoading(true)
        await axios.get(`${url}/video_kyc_pending_agent`,{
            headers:{
                Authorization:`Bearer ${sessionStorage.getItem("token")}`
            },
            params:{
                page,
                ...filters
            }
        })
        .then((response)=>{
            setData(response.data)
            isLoading(false)
        })

    } catch (error) {
        console.log(error);
        isLoading(false)
    }
}


export const generateAgentCode=async(data,setErrorMessage,setErrorType,handleErrorOpen,setData, setIsLoading,Filters,Page)=>{
    setIsLoading(true)
    try {
        await axios.post(`${url}/check_video_kyc_status`,{
            "user_id":data._id
        })
        .then((response)=>{
            setIsLoading(false)
            setErrorMessage(response.data.message?response.data.message:"Approved successfully.")
            setErrorType('success')
            handleErrorOpen()
            setTimeout(()=>{
                getVideoKycRequests(Filters,Page,setData,setIsLoading,)
            },1500)
        })
        .catch((error)=>{
            setIsLoading(false)
            setErrorMessage(error.response?error.response.data.error:'Something went wrong')
            setErrorType('error')
            handleErrorOpen()
        })

    } catch (error) {
        // console.log(error);
        setIsLoading(false)
        setErrorMessage(error.response?error.response.data.error:'Something went wrong')
        setErrorType('error')
        handleErrorOpen()

    }
}